import { Button as MuiButton, CircularProgress, useTheme } from '@mui/material';
import { ButtonProps } from './Button.props';

export const Button = ({
  loading = false,
  disabled,
  children,
  startIcon,
  endIcon,
  size = 'm',
  ...props
}: ButtonProps) => {
  const theme = useTheme();

  // Get spinner size from theme if available, otherwise use default
  const getSpinnerSize = () => {
    const themeSize = theme.size?.button?.[size]?.width;
    return themeSize ?? 20; // Default fallback size
  };

  return (
    <MuiButton
      disabled={disabled || loading}
      size={size}
      startIcon={
        loading ? (
          <CircularProgress size={getSpinnerSize()} color="inherit" />
        ) : (
          startIcon
        )
      }
      endIcon={loading ? undefined : endIcon}
      {...props}
    >
      {children}
    </MuiButton>
  );
};

export default Button;
